import * as z from "zod";

export const getUpsellDailyMetrics = {
  name: "getUpsellDailyMetrics" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    /** IANA time zone the day buckets are computed in (e.g. "America/New_York"). */
    timeZone: z.string(),
  }),
  output: z.object({
    dailyMetrics: z.array(
      z.object({
        // Local calendar day in the requested time zone, "YYYY-MM-DD".
        day: z.string(),
        totalRevenue: z.number(),
        totalVisits: z.number(),
        totalAcceptedOffers: z.number(),
      }),
    ),
  }),
};
export type GetUpsellDailyMetricsOutput = z.infer<
  typeof getUpsellDailyMetrics.output
>;
